import React, { useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { Table as BootstrapTable } from 'react-bootstrap';

// GLOBAL HELPERS
import { ListContext } from 'helpers/getListData';

// BOOTSTRAP COMPONENTS
import { Col, Row } from 'react-bootstrap';

// GLOBAL COMPONENTS
import Table from 'parts/table/Table';

// STYLES
import styles from './overviewTable.module.scss';

// VARIABLES
const HEADERS = ['Type', 'Total', 'Backout', 'Net', 'Avg'];
const TABLE = [
  [
    {
      label: 'Frontend Gross Before Pack'
    },
    {
      key: 'fe_gross_bp_total',
      name: 'Total'
    },
    {
      key: 'fe_gross_bp_backout',
      name: 'Backout'
    },
    {
      key: 'fe_gross_bp_net',
      name: 'Net'
    },
    {
      key: 'fe_gross_bp_avg',
      name: 'Avg'
    }
  ],
  [
    {
      label: 'Dealer Pack'
    },
    {
      key: 'dealer_pack_total',
      name: 'Total'
    },
    {
      key: 'dealer_pack_backout',
      name: 'Backout'
    },
    {
      key: 'dealer_pack_net',
      name: 'Net'
    },
    {
      key: 'dealer_pack_avg',
      name: 'Avg'
    }
  ],
  [
    {
      label: 'Frontend Gross After Pack'
    },
    {
      key: 'fe_gross_ap_total',
      name: 'Total'
    },
    {
      key: 'fe_gross_ap_backout',
      name: 'Backout'
    },
    {
      key: 'fe_gross_ap_net',
      name: 'Net'
    },
    {
      key: 'fe_gross_ap_avg',
      name: 'Avg'
    }
  ],
  [
    {
      label: 'AM Gross'
    },
    {
      key: 'am_gross_total',
      name: 'Total'
    },
    {
      key: 'am_gross_backout',
      name: 'Backout'
    },
    {
      key: 'am_gross_net',
      name: 'Net'
    },
    {
      key: 'am_gross_avg',
      name: 'Avg'
    }
  ],
  [
    {
      label: 'F&I Gross'
    },
    {
      key: 'fi_gross_total',
      name: 'Total'
    },
    {
      key: 'fi_gross_backout',
      name: 'Backout'
    },
    {
      key: 'fi_gross_net',
      name: 'Net'
    },
    {
      key: 'fi_gross_avg',
      name: 'Avg'
    }
  ],
  [
    {
      label: 'Backend Gross'
    },
    {
      key: 'be_gross_total',
      name: 'Total'
    },
    {
      key: 'be_gross_backout',
      name: 'Backout'
    },
    {
      key: 'be_gross_net',
      name: 'Net'
    },
    {
      key: 'be_gross_avg',
      name: 'Avg'
    }
  ],
  [
    {
      label: 'Grand Total'
    },
    {
      key: 'grand_total_total',
      name: 'Total'
    },
    {
      key: 'grand_total_backout',
      name: 'Backout'
    },
    {
      key: 'grand_total_net',
      name: 'Net'
    },
    {
      key: 'grand_total_avg',
      name: 'Avg'
    }
  ]
];

// MAIN COMPONENT
const OverviewTable = () => {
  // CONTEXT
  const { data } = useContext(ListContext) || {};

  // REDUX
  const { phone } = useSelector(({ mobile }) => mobile);

  // RENDER
  return phone ? (
    TABLE.map(row => (
      <>
        <h5 className="mb-2 fw-bolder text-primary">{row[0].label}</h5>
        <Row className="mx-0 mb-4 border-top border-bottom border-right">
          {row
            .filter((_v, i) => !!i)
            .map(({ key }, j) => (
              <Col key={j} xs={12} sm={6} className="py-3 border-left">
                <div className="text-muted text-end">{HEADERS[j + 1]}</div>
                <div className="mt-3 large">{<Table.Dollars>{data[key]}</Table.Dollars>}</div>
              </Col>
            ))}
        </Row>
      </>
    ))
  ) : (
    <BootstrapTable className={clsx('my-4', styles.table)} striped>
      <thead>
        <tr>
          {HEADERS.map((label, i) => (
            <th
              key={i}
              className={clsx('border-bottom', i !== 0 && 'text-end')}
              style={{ width: i === 0 ? '30%' : undefined }}
            >
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {TABLE.map((row, i) => (
          <tr key={i}>
            {row.map(({ key, label }, j) => (
              <td key={j}>{j === 0 ? label : <Table.Dollars>{data[key]}</Table.Dollars>}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </BootstrapTable>
  );
};

export default OverviewTable;
